// client/src/utils/imageUrl.js
import { API_URL } from "../config/env";

/**
 * Resuelve una ruta de imagen a su URL completa y absoluta.
 * - Si ya es una URL absoluta (http/https), la devuelve tal cual.
 * - Si es una ruta relativa local (ej: /uploads/imagen.jpg), concatena API_URL sin fallbacks en código.
 * 
 * @param {string} path - Ruta o URL de la imagen
 * @returns {string|null} URL completa o null si no se proporciona ruta
 */
export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const base = API_URL ? API_URL.replace(/\/+$/, "") : "";
  return `${base}${cleanPath}`;
};

export default getImageUrl;
